// Cấu trúc: Nhóm lớn trong drawer -> menu con -> các quyền của menu con.
// `key` chỉ định danh menu; `code` phải trùng với code trong bảng policies.
// `gradeScoped`: quyền tách theo khối bằng mã `<code>:grade-<N>` (xem helpers/gradeScope, docs/README-grade-permission.md).
const createMenu = (title, key, permissions) => ({title, key, permissions})
const createPermission = (code, label, options = {}) => ({code, label, ...options})
const gradeScoped = {gradeScoped: true}

export default [
  {
    title: 'Hồ sơ tuyển sinh',
    value: 'cv',
    permission: createPermission('view-cv-category', 'Hiển thị danh mục Hồ sơ tuyển sinh'),
    menus: [
      createMenu('QL Hồ sơ xét tuyển', 'document', [createPermission('view-cv', 'QL Hồ sơ xét tuyển', gradeScoped)]),
      createMenu('QL Hồ sơ đã hủy', 'document-cancel', [
        createPermission('view-cancel-cv', 'QL Hồ sơ đã hủy', gradeScoped),
      ]),
      createMenu('QL Xét duyệt ưu đãi', 'incentive-review', [
        createPermission('view-incentive-review', 'QL Xét duyệt ưu đãi', gradeScoped),
      ]),
      createMenu('QL Thông tin ưu đãi', 'incentive-references', [
        createPermission('view-incentive-references', 'QL Thông tin ưu đãi'),
      ]),
      createMenu('CH Thông tin trên hồ sơ', 'document-template', [
        createPermission('view-document-template', 'CH Thông tin trên hồ sơ', gradeScoped),
      ]),
      createMenu('CH Biểu mẫu xác nhận', 'pdf-template', [
        createPermission('view-pdf-template', 'CH Biểu mẫu xác nhận', gradeScoped),
      ]),
      createMenu('CH Bước khai hồ sơ', 'display-setting-step', [
        createPermission('view-step-display-setting', 'CH Bước khai hồ sơ', gradeScoped),
      ]),
      createMenu('Chi tiết hồ sơ', 'cv-detail', [
        ...[1, 2, 3, 4, 5, 6].map(step =>
          createPermission(`view-grade6-cv-detail-step-${step}`, `Xem hồ sơ lớp 6 - Bước ${step}`),
        ),
        ...[1, 2, 3, 4, 5, 6].map(step =>
          createPermission(`view-grade10-cv-detail-step-${step}`, `Xem hồ sơ lớp 10 - Bước ${step}`),
        ),
      ]),
    ],
  },
  {
    title: 'KS ĐGNL',
    value: 'exam',
    permission: createPermission('view-exam-category', 'Hiển thị danh mục KS ĐGNL'),
    menus: [
      createMenu('QL Kỳ KSDGNL', 'exams', [createPermission('manage-exam', 'QL Kỳ KSDGNL', gradeScoped)]),
      createMenu('QL Đợt đăng ký', 'exam-registration-rounds', [
        createPermission('manage-exam-registration-rounds', 'QL Đợt đăng ký', gradeScoped),
      ]),
      createMenu('QL Hồ sơ đăng ký', 'students', [
        createPermission('manage-exam-students', 'QL Hồ sơ đăng ký', gradeScoped),
      ]),
      createMenu('Duyệt miễn thi khối 1', 'direct-admissions-grade1', [
        createPermission('approve-direct-admissions-grade1', 'Duyệt miễn thi khối 1'),
      ]),
      createMenu('Duyệt miễn thi khối 6', 'direct-admissions-grade6', [
        createPermission('approve-direct-admissions-grade6', 'Duyệt miễn thi khối 6'),
      ]),
      createMenu('Duyệt miễn thi khối 10', 'direct-admissions-grade10', [
        createPermission('approve-direct-admissions-grade10', 'Duyệt miễn thi khối 10'),
      ]),
      createMenu('QL Số túi & mã phách', 'code', [
        createPermission('manage-exam-codes', 'QL Số túi & mã phách', gradeScoped),
      ]),
      createMenu('QL Số Biên bản KS', 'absent', [
        createPermission('manage-exam-absences', 'QL Số Biên bản KS', gradeScoped),
      ]),
      createMenu('QL Nhập điểm', 'mark-input', [
        createPermission('input-exam-marks', 'QL Nhập điểm', gradeScoped),
        createPermission('input-all-marks', 'Nhập điểm cho toàn bộ học sinh'),
      ]),
      createMenu('QL Điểm (sau khớp phách)', 'mark-view', [
        createPermission('view-exam-marks', 'QL Điểm (sau khớp phách)', gradeScoped),
        createPermission('view-all-marks', 'Xem toàn bộ điểm thi'),
      ]),
      createMenu('QL Phúc khảo', 'student-review', [
        createPermission('manage-student-reviews', 'QL Phúc khảo', gradeScoped),
      ]),
      createMenu('QL Kết quả KSĐGNL 1', 'grade1-result', [
        createPermission('view-result-1', 'QL Kết quả KSĐGNL 1'),
      ]),
      createMenu('QL Kết quả KSĐGNL 6', 'grade6-result', [
        createPermission('view-result-6', 'QL Kết quả KSĐGNL 6'),
      ]),
      createMenu('QL Kết quả KSĐGNL 10', 'grade10-result', [
        createPermission('view-result-10', 'QL Kết quả KSĐGNL 10'),
      ]),
      createMenu('QL Báo cáo', 'statistics', [createPermission('view-exam-statistics', 'QL Báo cáo', gradeScoped)]),
    ],
  },
  {
    title: 'Kết quả tuyển sinh',
    value: 'admission',
    permission: createPermission('view-admission-category', 'Hiển thị danh mục Kết quả tuyển sinh'),
    menus: [
      createMenu('QL Hồ sơ trúng tuyển', 'admission-list', [
        createPermission('view-admission-list', 'QL Hồ sơ trúng tuyển', gradeScoped),
      ]),
      createMenu('QL Xét duyệt tuyển thẳng', 'direct-admission-review', [
        createPermission('view-direct-admission-review', 'QL Xét duyệt tuyển thẳng', gradeScoped),
      ]),
      createMenu('QL Xét duyệt thủ công', 'admission-review', [
        createPermission('view-admission-review', 'QL Xét duyệt thủ công', gradeScoped),
      ]),
      createMenu('CH Phương thức TS', 'admission-method', [
        createPermission('view-admission-config', 'CH Phương thức TS', gradeScoped),
      ]),
      createMenu('CH Công thức TS', 'admission-formula', [
        createPermission('view-admission-config', 'CH Công thức TS', gradeScoped),
      ]),
      createMenu('CH Điều kiện trúng tuyển', 'admission-plan', [
        createPermission('view-admission-config', 'CH Điều kiện trúng tuyển', gradeScoped),
      ]),
      createMenu('CH Hệ tuyển thẳng', 'direct-admission-product', [
        createPermission('view-admission-config', 'CH Hệ tuyển thẳng', gradeScoped),
      ]),
      createMenu('CH Ẩn / hiện KQ', 'display-setting-result-exam', [
        createPermission('view-result-display-setting', 'CH Ẩn / hiện KQ', gradeScoped),
      ]),
    ],
  },
  {
    title: 'Quản lý nhập học',
    value: 'enroll',
    permission: createPermission('view-enroll-category', 'Hiển thị danh mục Quản lý nhập học'),
    menus: [
      createMenu('QL Hồ sơ nhập học', 'online-enrollment', [
        createPermission('view-online-enrollment', 'QL Hồ sơ nhập học', gradeScoped),
      ]),
      createMenu('QL Chuyển đổi hệ ĐT', 'update-expectation', [
        createPermission('view-update-expectation', 'QL Chuyển đổi hệ ĐT', gradeScoped),
        createPermission('export-update-expectation-excel', 'Xuất Excel chuyển đổi hệ đào tạo'),
      ]),
      createMenu('QL Nhận hồ sơ gốc', 'submit-document', [
        createPermission('view-submit-document', 'QL Nhận hồ sơ gốc', gradeScoped),
        createPermission('edit-enroll-status', 'Chỉnh sửa thông tin nhập học'),
        createPermission('edit-submit-doc', 'Chỉnh sửa thu hồ sơ gốc'),
        createPermission('edit-subject-doc', 'Chỉnh sửa nhóm môn học'),
        createPermission('edit-service-doc', 'Chỉnh sửa dịch vụ'),
        createPermission('edit-payment-doc', 'Chỉnh sửa thu tiền'),
        createPermission('edit-restrict-subject-doc', 'Khóa nhóm môn học'),
        createPermission('edit-restrict-service-doc', 'Khóa dịch vụ'),
        createPermission('view-submit-doc-excel', 'Tải file dữ liệu hồ sơ gốc'),
        createPermission('view-submit-doc-history', 'Xem lịch sử chỉnh sửa'),
      ]),
      createMenu('QL Đơn nhập học', 'enroll-forms', [
        createPermission('view-registration-form-1', 'Xem đơn nhập học khối 1'),
        createPermission('view-registration-form-6', 'Xem đơn nhập học khối 6'),
        createPermission('view-registration-form-10', 'Xem đơn nhập học khối 10'),
      ]),
      createMenu('QL Xếp lớp', 'grade1-class-assignment', [
        createPermission('manage-primary-class-assignment', 'QL Xếp lớp'),
      ]),
      createMenu('QL Đơn hủy nhập học', 'document-enroll-cancel', [
        createPermission('view-cancel-enroll-cv', 'QL Đơn hủy nhập học', gradeScoped),
      ]),
      createMenu('CH Chỉ tiêu tuyển sinh', 'enroll-capacity', [
        createPermission('view-enroll-capacity', 'CH Chỉ tiêu tuyển sinh', gradeScoped),
      ]),
      createMenu('QL Khóa / mở nhập học', 'enrollment-window', [
        createPermission('view-enrollment-window', 'QL Khóa / mở nhập học', gradeScoped),
      ]),
    ],
  },
  {
    title: 'CRM – Chuyển đổi Hồ sơ',
    value: 'crm',
    permission: createPermission('view-crm-category', 'Hiển thị danh mục CRM – Chuyển đổi Hồ sơ'),
    menus: [
      createMenu('QL Hồ sơ tiềm năng', 'lead', [createPermission('view-lead', 'QL Hồ sơ tiềm năng')]),
      createMenu('QL Báo cáo', 'crm-report', [createPermission('view-report-crm', 'QL Báo cáo')]),
      createMenu('QL Nhân viên Sale', 'sale', [createPermission('view-sale-user', 'QL Nhân viên Sale')]),
    ],
  },
  {
    title: 'Email & SMS',
    value: 'communication',
    permission: createPermission('view-communication-category', 'Hiển thị danh mục Email & SMS'),
    menus: [
      createMenu('Gửi Email', 'email', [createPermission('view-email', 'Gửi Email', gradeScoped)]),
      createMenu('Gửi tin SMS', 'sms', [createPermission('view-sms', 'Gửi tin SMS', gradeScoped)]),
    ],
  },
  {
    title: 'Nội dung cổng tin',
    value: 'website',
    permission: createPermission('view-website-category', 'Hiển thị danh mục Nội dung cổng tin'),
    menus: [
      createMenu('QL Banner', 'setting-banner', [createPermission('view-banner-setting', 'QL Banner', gradeScoped)]),
      createMenu('CH Thông tin tuyển sinh 1', 'bulletin-1', [
        createPermission('view-board-1', 'CH Thông tin tuyển sinh 1'),
      ]),
      createMenu('CH Thông tin tuyển sinh 6', 'bulletin-6', [
        createPermission('view-board-6', 'CH Thông tin tuyển sinh 6'),
      ]),
      createMenu('CH Thông tin tuyển sinh 10', 'bulletin-10', [
        createPermission('view-board-10', 'CH Thông tin tuyển sinh 10'),
      ]),
      createMenu('CH Hướng dẫn tuyển sinh 1', 'instruction-1', [
        createPermission('view-instruction-1', 'CH Hướng dẫn tuyển sinh 1'),
      ]),
      createMenu('CH Hướng dẫn tuyển sinh 6', 'instruction-6', [
        createPermission('view-instruction-6', 'CH Hướng dẫn tuyển sinh 6'),
      ]),
      createMenu('CH Hướng dẫn tuyển sinh 10', 'instruction-10', [
        createPermission('view-instruction-10', 'CH Hướng dẫn tuyển sinh 10'),
      ]),
      createMenu('Ql Popup', 'setting-popup', [createPermission('view-popup-setting', 'Ql Popup', gradeScoped)]),
      createMenu('QL Tin tức', 'enroll-news', [createPermission('view-information', 'QL Tin tức', gradeScoped)]),
      createMenu('QL Phiếu khảo sát', 'survey-form', [
        createPermission('view-survey', 'QL Phiếu khảo sát', gradeScoped),
        createPermission('create-survey', 'Tạo khảo sát'),
        createPermission('update-survey', 'Cập nhật và phát hành khảo sát'),
        createPermission('delete-survey', 'Xoá khảo sát'),
      ]),
    ],
  },
  {
    title: 'Sự kiện',
    value: 'event',
    permission: createPermission('view-event-category', 'Hiển thị danh mục Sự kiện'),
    menus: [createMenu('QL Sự kiện', 'event-list', [createPermission('view-event-list', 'QL Sự kiện')])],
  },
  {
    title: 'QL Tài chính',
    value: 'finance',
    permission: createPermission('view-finance-category', 'Hiển thị danh mục QL Tài chính'),
    menus: [
      // Hoá đơn điện tử: xem và phát hành tách theo khối (mỗi khối một người bán); backend kiểm tra cả hai.
      createMenu('QL hoá đơn', 'invoice-list', [
        createPermission('view-invoice', 'QL hoá đơn', gradeScoped),
        createPermission('issue-invoice', 'Phát hành / sửa / thay thế hoá đơn', gradeScoped),
        createPermission('config-invoice', 'Cấu hình VAT hoá đơn', gradeScoped),
      ]),
      // Phụ huynh nộp tiền mặt: xác nhận giao dịch đang chờ thay chuyển khoản (ghi nhận tiền + cập nhật hồ sơ)
      createMenu('Thu tiền mặt', 'cash-payment', [
        createPermission('confirm-cash-payment', 'Xác nhận thu tiền mặt', gradeScoped),
      ]),
      createMenu('CH Phí mở hồ sơ', 'application-fee', [
        createPermission('view-enroll', 'CH Phí mở hồ sơ', gradeScoped),
      ]),
    ],
  },
  {
    title: 'Báo cáo chung',
    value: 'report',
    permission: createPermission('view-report-category', 'Hiển thị danh mục Báo cáo chung'),
    menus: [
      createMenu('Xem BC thường xuyên', 'dashboard', [createPermission('view-report', 'Xem BC thường xuyên', gradeScoped)]),
      createMenu('Xem biểu đồ', 'dashboard-chart', [createPermission('view-report-chart', 'Xem biểu đồ', gradeScoped)]),
      createMenu('Xem BC theo năm', 'annual-report', [
        createPermission('view-annual-report', 'Xem BC theo năm', gradeScoped),
        createPermission('view-report-detail', 'Xem báo cáo chi tiết'),
      ]),
    ],
  },
  {
    title: 'Cài đặt hệ thống',
    value: 'accounts',
    permission: createPermission('view-accounts-category', 'Hiển thị danh mục Cài đặt hệ thống'),
    menus: [
      createMenu('QL TK PH', 'user', [createPermission('view-account', 'QL TK PH')]),
      createMenu('QL Người dùng / nhân sự', 'users-management', [
        createPermission('account-settings', 'QL Người dùng / nhân sự'),
      ]),
      createMenu('QL Phân quyền', 'policies', [createPermission('policies-setting', 'QL Phân quyền')]),
      createMenu('QL Hệ đào tạo', 'product', [createPermission('view-product', 'QL Hệ đào tạo', gradeScoped)]),
      createMenu('CH Hiển thị chung', 'display-setting', [
        createPermission('view-display-setting', 'CH Hiển thị chung', gradeScoped),
      ]),
    ],
  },
]
